import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseControl, ConfirmComponent, ObservacioneExpediente } from '@app/shared';
import { LocalDataSource } from 'ng2-smart-table';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ObservationProcessConfigService } from './shared/observation-process.config.service';
import { ObservationProcessDataService } from './shared/observation-process.data.service';
import { ObservationProcessFormService } from './shared/observation-process.form.service';

@Component({
  selector: 'iw-observation-process',
  templateUrl: './observation-process.component.html',
  styleUrls: ['./observation-process.component.scss'],
  providers: [ObservationProcessDataService, ObservationProcessFormService]
})
export class ObservationProcessComponent implements OnInit, OnDestroy {

  // Contiene el id del expediente
  @Input() process: number;
  // Contiene el radicado del expediente
  @Input() expediente: string;
  // Contiene el nombre del tramite
  @Input() tramite: string;
  // Define la accion a realizar
  actionForm: string;
  // Contiene las observaaciones
  observations: ObservacioneExpediente[];
  // Contiene el id de la observación
  idObservation: number;
  // Define cuando abrir el modal
  openForm = false;
  // Define cuando actualiza la observación
  updated = false;
  // Contiene los controles del formulario
  controls: BaseControl<any>[] = [];
  // Data de la tabla de observaciones
  sourceData: LocalDataSource;
  // Contiene la configuracion de la tabla
  settings = {};
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Controla si se muestra las tareas asociadas
  private destroy: Subject<void> = new Subject<void>();

  constructor(
    private opds: ObservationProcessDataService,
    private opfs: ObservationProcessFormService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    const configTable = new ObservationProcessConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.actionTable(res.action, res.data);
    });
    if (this.process) {
      this.loadObservationsProcess(false);
    } else {
      this.toastr.warning('No se indico ningun expediente', 'Información incompleta');
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Define la accion a realizar en la tabla
   *
   * @param {('add' | 'updated' | 'delete')} [action='add']
   * @param {*} data
   * @memberof ObservationProcessComponent
   */
  actionTable(action: 'add' | 'update' | 'delete' = 'add', data: any) {
    switch (action) {
      case 'update':
        this.controls = this.opfs.getFields(data);
        this.updated = true;
        this.actionForm = 'Actualizar';
        this.idObservation = data.id;
        this.openForm = true;
        break;
        case 'delete':
          this.confirm.new({
            question: 'Realmente desea eliminar la observación',
            labelConfirm: 'Sí',
            labelDecline: 'No'
          }).then(res => {
            if (res) {
              this.opds.deleteObservationProcess(data.id).then(result => {
                if (result) {
                  this.loadObservationsProcess(true);
                  this.closeForm();
                }
              });
            }
          });
          break;
      default:
        this.controls = this.opfs.getFields();
        this.updated = false;
        this.actionForm = 'Agregar';
        this.openForm = true;
        break;
    }
  }

  /**
   * Cierra el formulario de observaciones
   *
   * @memberof ObservationProcessComponent
   */
  closeForm() {
    this.controls = [];
    this.updated = false;
    this.actionForm = '';
    this.idObservation = -1;
    this.openForm = false;
  }

  /**
   * Agrega o edita una observacion a un expediente
   *
   * @param {*} data
   * @memberof ObservationProcessComponent
   */
  sended(data: any) {
    this.confirm.new({
      question: 'Realmente desea ' + this.actionForm.toLowerCase() + ' la observación',
      labelConfirm: 'Sí',
      labelDecline: 'No'
    }).then(res => {
      if (res) {
        if (this.updated) {
          this.opds.updateObservationProcess(this.idObservation, data.txtObservacion).then(result => {
            if (result) {
              this.loadObservationsProcess(true);
              this.closeForm();
            }
          });
        } else {
          this.opds.addObservationProcess(this.process, data.txtObservacion).then(result => {
            if (result) {
              this.loadObservationsProcess(true);
              this.closeForm();
            }
          });
        }
      }
    });
  }

  /**
   * Carga las observaciones en la tabla
   *
   * @private
   * @memberof ObservationProcessComponent
   */
  private loadObservationsProcess(close: boolean) {
    this.opds.getObservations(this.process).subscribe(observations => {
      this.observations = observations;
      this.sourceData = new LocalDataSource(observations);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/observation-process/observation-process.component.ts